import { callGuestAPI } from "../axios/guestAxios";

async function requestDetailsOtp({ email, phone }) {
  const options = {
    method: "POST",
    url: "/reservation/v1/request-details-otp",
    data: { email, phone },
  };
  return await callGuestAPI(options);
}

async function verifyDetailsOtp({ email, phone, otpCode }) {
  const options = {
    method: "POST",
    url: "/reservation/v1/verify-details-otp",
    data: { email, phone, otp_code: otpCode },
  };
  return await callGuestAPI(options);
}

async function getDonorDetails({ token, donorId }) {
  const options = {
    method: "GET",
    url: "/reservation/v1/self-service/donor-details",
    params: { token, donor_id: donorId },
  };
  return await callGuestAPI(options);
}

async function updateDonorDetails({ token, donorId, data }) {
  const options = {
    method: "PUT",
    url: "/reservation/v1/self-service/donor-details",
    params: { token, donor_id: donorId },
    data,
  };
  return await callGuestAPI(options);
}

async function updateReservationDate({ token, donorId, reservationId, newDate, oldDate, fullname, contactNo, whatsappNo }) {
  const options = {
    method: "PUT",
    url: "/reservation/v1/self-service/reservation-date",
    params: { token, donor_id: donorId },
    data: {
      reservationId,
      newDate,
      oldDate,
      fullname,
      contactNo,
      whatsappNo,
    },
  };
  return await callGuestAPI(options);
}

async function updateReservationDateSeries({ token, donorId, newDate, oldDate }) {
  const options = {
    method: "PUT",
    url: "/reservation/v1/self-service/reservation-date-series",
    params: { token, donor_id: donorId },
    data: { newDate, oldDate },
  };
  return await callGuestAPI(options);
}

const SelfServiceServices = {
  requestDetailsOtp,
  verifyDetailsOtp,
  getDonorDetails,
  updateDonorDetails,
  updateReservationDate,
  updateReservationDateSeries,
};

export default SelfServiceServices;
